import { createSlice } from '@reduxjs/toolkit';

import { AppNS } from '..';
import { AppThunk } from './index';

import { apiSetClaimAccountDetails, registerUser } from '../api/users';
import { updateUserData } from './auth';

export interface AgencyOnboardingState {
  isRegisterAgencyLoading: boolean;
  isRegisterAgencyRequested: boolean;
  isRegisterAgencySuccess: boolean;
}

const initialState: AgencyOnboardingState = {
  isRegisterAgencyLoading: false,
  isRegisterAgencyRequested: false,
  isRegisterAgencySuccess: false,
};

const agencyOnboardingSlice = createSlice({
  name: 'agencyOnboarding',
  initialState,
  reducers: {
    registerAgencyReset(state: AgencyOnboardingState) {
      state.isRegisterAgencyRequested = false;
      state.isRegisterAgencyLoading = false;
      state.isRegisterAgencySuccess = false;
    },
    registerAgencyStart(state: AgencyOnboardingState) {
      state.isRegisterAgencyRequested = false;
      state.isRegisterAgencyLoading = true;
      state.isRegisterAgencySuccess = false;
    },
    registerAgencySuccess(state: AgencyOnboardingState) {
      state.isRegisterAgencyRequested = true;
      state.isRegisterAgencyLoading = false;
      state.isRegisterAgencySuccess = true;
    },
    registerAgencyFailed(state: AgencyOnboardingState) {
      state.isRegisterAgencyRequested = true;
      state.isRegisterAgencySuccess = false;
      state.isRegisterAgencyLoading = false;
    },
  },
});

export const {
  registerAgencyFailed,
  registerAgencyStart,
  registerAgencySuccess,
  registerAgencyReset,
} = agencyOnboardingSlice.actions;

export default agencyOnboardingSlice.reducer;

export const registerAgency =
  (params: AppNS.Params): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(registerAgencyStart());
      await registerUser(params);
      dispatch(registerAgencySuccess());
    } catch (err) {
      console.error(err.toString());
      dispatch(registerAgencyFailed());
    }
  };

export const setClaimAccountDetails =
  (params: AppNS.Params, currentAddressId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(registerAgencyStart());
      const response = await apiSetClaimAccountDetails(params);
      dispatch(
        updateUserData({
          id: response.id,
          ...response.properties,
          address: [
            { ...params.models.address[0].properties, id: currentAddressId },
          ],
        })
      );
      dispatch(registerAgencySuccess());
    } catch (err) {
      console.error(err.toString());
      dispatch(registerAgencyFailed());
    }
  };
